import React, { useEffect, useRef } from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { gsap } from '../../lib/gsap';
import { projectsData } from '../../data/projectsData';
import './Projects.css';

function Projects() {
  const wrapperRef = useRef(null);
  const trackRef = useRef(null);

  useEffect(() => {
    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    if (isMobile) return undefined;

    const track = trackRef.current;
    if (!track) return undefined;

    const distance = track.scrollWidth - window.innerWidth;
    const slides = gsap.utils.toArray('.project-slide');

    const ctx = gsap.context(() => {
      const hpanTween = gsap.to(track, {
        x: -distance,
        ease: 'none',
        scrollTrigger: {
          trigger: wrapperRef.current,
          start: 'top top',
          end: () => `+=${distance}`,
          pin: true,
          scrub: 1,
          invalidateOnRefresh: true,
        },
      });

      slides.forEach((slide) => {
        const inner = slide.querySelector('.project-slide-inner');
        if (!inner) return;
        gsap.fromTo(
          inner,
          { scale: 0.92, opacity: 0.3 },
          {
            scale: 1,
            opacity: 1,
            ease: 'none',
            scrollTrigger: {
              trigger: slide,
              containerAnimation: hpanTween,
              start: 'left 80%',
              end: 'left 30%',
              scrub: true,
            },
          }
        );
      });
    }, wrapperRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="projects-section" id="projects">
      <div className="projects-header">
        <h2 className="section-title">Featured work</h2>
      </div>

      <div className="projects-hpan-wrapper" ref={wrapperRef}>
        <div className="projects-hpan-track" ref={trackRef}>
          {projectsData.map((project, idx) => (
            <div key={project.id} className="project-slide">
              <div className="project-slide-inner">
                <div className="project-slide-img-wrap">
                  {project.video ? (
                    <video
                      src={project.video}
                      poster={project.image}
                      className="project-slide-img"
                      autoPlay
                      loop
                      muted
                      playsInline
                    />
                  ) : (
                    <img
                      src={project.image}
                      alt={project.projectName}
                      className="project-slide-img"
                    />
                  )}
                </div>

                <div className="project-slide-copy">
                  <span className="project-slide-num">0{idx + 1}</span>
                  <h3 className="project-slide-title">{project.projectName}</h3>
                  <p className="project-slide-desc">{project.projectDesc}</p>

                  <div className="project-slide-tags">
                    {project.tags.map((tag) => (
                      <span key={tag} className="project-slide-tag">{tag}</span>
                    ))}
                  </div>

                  {project.demo && (
                  <a
                    href={project.demo}
                    target="_blank"
                    rel="noreferrer"
                    className="cta-pill project-slide-cta"
                  >
                    <span>Live application</span>
                    <div className="icon-wrapper" aria-hidden="true">
                      <FaExternalLinkAlt style={{ fontSize: '0.78rem' }} />
                    </div>
                  </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
